/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_Row_TemperatureInputs */

const en_ui_weather_row_temperature = /** @type {(inputs: Ui_Weather_Row_TemperatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temp`)
};

const de_ui_weather_row_temperature = /** @type {(inputs: Ui_Weather_Row_TemperatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temp.`)
};

/**
* | output |
* | --- |
* | "Temp" |
*
* @param {Ui_Weather_Row_TemperatureInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_row_temperature = /** @type {((inputs?: Ui_Weather_Row_TemperatureInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Row_TemperatureInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_row_temperature(inputs)
	return de_ui_weather_row_temperature(inputs)
});